import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbDialogService,
  NbSpinnerModule,
} from '@nebular/theme';
import { forkJoin, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Pessoa } from '../../../core/api/pessoa';
import { PessoaService } from '../../../core/api/pessoa.service';
import { TurmaCatequizandoDto } from '../../../core/api/turma-catequizando.dto';
import { PessoaTheosDetalheDto } from '../../../core/api/pessoa-theos-detalhe.dto';
import { Turma } from '../../../core/api/turma';
import { mensagemDeErro } from '../../../utils/mensagem-erro';
import { TurmaDetalhesDialogComponent } from '../../turma/turma-detalhes-dialog/turma-detalhes-dialog.component';

@Component({
  selector: 'app-pessoa-detalhes-dialog',
  standalone: true,
  imports: [CommonModule, NbCardModule, NbButtonModule, NbSpinnerModule],
  templateUrl: './pessoa-detalhes-dialog.component.html',
  styleUrls: ['./pessoa-detalhes-dialog.component.scss'],
})
export class PessoaDetalhesDialogComponent implements OnInit {
  @Input({ required: true }) pessoa!: Pessoa;

  carregando = true;
  erroTurmas: string | null = null;
  erroTheos: string | null = null;
  turmas: TurmaCatequizandoDto[] = [];
  theos: PessoaTheosDetalheDto | null = null;

  constructor(
    private pessoaService: PessoaService,
    private dialogService: NbDialogService,
    protected ref: NbDialogRef<PessoaDetalhesDialogComponent>,
  ) {}

  ngOnInit(): void {
    const id = this.pessoa.id;
    if (!id) {
      this.carregando = false;
      this.erroTurmas = 'Pessoa sem identificador.';
      return;
    }
    forkJoin({
      turmas: this.pessoaService.listarTurmasPessoa(id).pipe(
        catchError((err) => {
          this.erroTurmas = mensagemDeErro(err, 'Não foi possível carregar as turmas.');
          return of<TurmaCatequizandoDto[]>([]);
        }),
      ),
      theos: this.pessoaService.buscarDetalhesTheos(id).pipe(
        catchError((err) => {
          this.erroTheos = mensagemDeErro(err, 'Não foi possível carregar os dados do Theos.');
          return of<PessoaTheosDetalheDto | null>(null);
        }),
      ),
    })
      .pipe(finalize(() => (this.carregando = false)))
      .subscribe(({ turmas, theos }) => {
        this.turmas = Array.isArray(turmas) ? turmas : [];
        this.theos = theos;
      });
  }

  fechar(): void {
    this.ref.close();
  }

  simNao(v: boolean | undefined | null): string {
    return v === true ? 'Sim' : 'Não';
  }

  trackByTurma = (_: number, t: TurmaCatequizandoDto): string =>
    t.id ?? t.turmaId ?? String(_);

  abrirDetalhesTurma(t: TurmaCatequizandoDto, ev?: Event): void {
    ev?.preventDefault();
    const id = t.turmaId?.trim();
    if (!id) return;
    this.dialogService.open(TurmaDetalhesDialogComponent, {
      context: { turma: new Turma({ id, nome: t.turmaNome }) },
    });
  }
}
